import { Html, useBounds } from "@react-three/drei";
import { useCustomBounds } from "./Components/CustomBounds";
import { useState } from "react";
import { cloneElement } from "react";
import { deepMap } from "react-children-utilities";

import { CustomBounds } from "./Components/CustomBounds";
import Dialogue from "./Components/Dialogue";

export const addProps = (child, newProps) => cloneElement(child, newProps);
export const addBounds = (
  child,
  { damping, margin, position, targetObject: objectToZoom }
) => {
  return (
    <CustomBounds
      clip
      observe
      damping={damping}
      margin={margin}
      fullRoom={false}
      meshName={child.props.name}
    >
      <ZoomIn position={position} fullRoom={false} objectToZoom={objectToZoom}>
        {child}
      </ZoomIn>
    </CustomBounds>
  );
};

export const addBasicBounds = (child, { damping, margin }) => {
  return (
    <CustomBounds
      clip
      observe
      damping={damping}
      margin={margin}
      fullRoom={false}
      meshName={child.props.name}
    >
      <ZoomIn fullRoom={false}>{child}</ZoomIn>
    </CustomBounds>
  );
};

export const Mods = ({ children, modifications }) =>
  deepMap(children, (child, i) =>
    cloneElement(modifications(child, child.props), {
      key: "modified-" + child.key,
    })
  );

export const defaultCameraPosition = [4, 3, 2];
export const defaultDamping = 6;
export const defaultMargin = 1.2;

export const controlsState = {
  isEnabled: false,
};

export const urlPrefixer = (filename) => {
  console.log(import.meta.env);
  return import.meta.env.BASE_URL + filename;
};

export const hideDialogue = () => {
  console.log("force hide dialogue event sent");
  document.querySelector(".dialogue-container").dispatchEvent(new Event("hide"));
}

// CORS proxy is running on localhost:8080, we use it on dev
export const UnityBuildPrefix = (pathName) => { 
  const buildName = pathName || "reacttest";
  return import.meta.env.MODE === "production" 
  ? "https://lusi-dataviz.test.ylestatic.fi/2023-04-unity-teininhuone/" +buildName + "/Build"
  : "http://localhost:8080/lusi-dataviz.test.ylestatic.fi/2023-04-unity-teininhuone/" +buildName + "/Build";
}
export const useZoomEnded = () => {
  const [zoomEnded, setZoomEnded] = useState({ value: false, meta: {} });

  return [zoomEnded, setZoomEnded];
};

export function ZoomOut({ children, fullRoom }) {
  const api = useCustomBounds();

  const handleClick = (e) => {
    console.log("button clicked");
    if (!controlsState.isEnabled) return;
    e.stopPropagation();
    e.button === 0 && api.refresh().fit();
    api.to({ position: defaultCameraPosition, target: [0, 0, 0] });
  };
  return (
    <>
      <Html>
        <button onClick={handleClick}>zoom out button</button>
      </Html>
      <group>{children}</group>
    </>
  );
}

export function ExitButton({}) {
  const api = useCustomBounds();
  console.log(api);
  const handleClick = (e) => {
    console.log("button clicked");

    if (!controlsState.isEnabled) return;
    e.stopPropagation();
    e.button === 0 && api.refresh().fit();
    api.to({ position: defaultCameraPosition, target: [0, 0, 0] });
  };
  return (
    <div>
      <button style={{ zIndex: 100000 }} onClick={handleClick}>
        CLICK ME
      </button>
    </div>
  );
}

export function ZoomIn({ children, position, objectToZoom }) {
  const api = useCustomBounds();
  return (
    <group
      //klikkaus esineeseen zoomaa
      onClick={(e) => {
        e.stopPropagation();

        if (e.delta > 2) {
          return;
        }
        api.refresh(objectToZoom || e.object).fit();
        if (position) {
          api.to({ position });
        }
      }}
    >
      {children}
    </group>
  );
}

export class ZoomEndEvent extends Event {
  constructor({ isFullRoom, meshName }) {
    super("zoomEnded");
    this.isFullRoom = isFullRoom;
    this.meshName = meshName;
  }
}

export class ZoomStartEvent extends Event {
  constructor({ isFullRoom, meshName }) {
    super("zoomStarted");
    this.isFullRoom = isFullRoom;
    this.meshName = meshName;
  }
}

export const ZoomEventTarget = new (class CustomEvt extends EventTarget {})();

